import { CricketMatchModel, GameType, Market, MatchModelBase } from '@nf/types/odds';
import { matchEquals } from '@nf/utils-common/fpw/monadic';

export const getMatchMoreBetTypeCount = (match: MatchModelBase, markets: Market[], gameType: GameType): number => {
	return matchEquals(match.GameID)
		.on(50, () => {
			const fancyMoreCount = ((match as CricketMatchModel).Mocfc || 0) + markets.filter(market => market.gt === 'fc').length;
			return gameType === 'FC' ? fancyMoreCount : (match.Moc + markets.length - fancyMoreCount);
		})
		.otherwise(() => match.Moc + markets.length)
}

/**
 * 解析供應商列表的資料 (for statistic info)
 * @param match match data from odds server
 * @param key provider id
 */
export const getMatchIdFromProviderList = (match: MatchModelBase, key: string): number => {
	return match?.PST?.[key] ?? 0;
}